module.exports = __webpack_public_path__ + "static/media/0102.9ef617f1.png";